// import Button from '@mui/material/Button';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '~/hooks/useAuth';
import { Avatar } from '../Avatar';
import { Badge, Menu, MenuItem } from '@mui/material';
import { BookOutlined, ControlPointOutlined, FactCheckOutlined, Group, Logout, SettingsOutlined } from '@mui/icons-material';
import Button from '@mui/material/Button';
import axios from 'axios';
import { AddTaskModal } from '~/components/tasks/AddTaskModal';
import { useTasksCount } from '~/hooks/useTaskCount';
function navLinkClassName({ isActive }) {
    return clsx('text-sm font-bold uppercase px-3 py-1 border-2 rounded-md tracking-wide text-app-mui-blue', {
        'border-transparent hover:border-app-sky-blue hover:text-app-mui-blue': !isActive,
        'border-app-sky-blue text-app-mui-blue': isActive,
    });
}
export const AppHeader = () => {
    const { signOut, userProfile } = useAuth();
    const [showProfileActions, setShowProfileActions] = useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [showTasksMenu, setShowTasksMenu] = useState(false);
    const [tasksAnchorEl, setTasksAnchorEl] = React.useState(null);
    const [showAddTasksModal, setShowAddTasksModal] = useState(false);
    const [currentUrl, setCurrentUrl] = useState('');
    const location = useLocation();
    // Check if current path matches any of the dropdown options
    const isActive = location.pathname.startsWith('/tasks');
    // const activeClasses = 'text-sm font-bold uppercase px-3 py-1 border-2 rounded-md tracking-wide text-app-mui-blue border-app-sky-blue';
    // const inactiveClasses = 'text-sm font-bold uppercase px-3 py-1 border-2 rounded-md tracking-wide text-app-mui-blue border-transparent hover:border-app-sky-blue hover:text-app-mui-blue';
    useEffect(() => {
        setCurrentUrl(window.location.href);
    }, []);
    const { data: tasksCount = 0 } = useTasksCount();
    const handleProfileMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
        setShowProfileActions(true);
        console.log('showing bulk actions');
    };
    const handleTasksMenuClick = (event) => {
        setTasksAnchorEl(event.currentTarget);
        setShowTasksMenu(true);
    };
    const handleCloseProfileActions = () => {
        setAnchorEl(null);
        setShowProfileActions(false);
    };
    const handleCloseTasksMenu = () => {
        setTasksAnchorEl(null);
        setShowTasksMenu(false);
    };
    if (!userProfile) {
        throw new Error('Missing required user profile');
    }
    const launchAegisDashboard = async () => {
        const response = await axios.post('/api/aegisDashboard/signUserIntoAegisAccount', {});
        if (response.data.data.access_token) {
            // Replace the old token with the new one
            localStorage.setItem('access_token', response.data.data.access_token);
            // Redirect to the sub-user home page
            window.location.href = '/aegisDashboard'; // adjust as needed
        }
        else {
            console.error('Login as sub-user failed', response.data);
        }
    };
    return (React.createElement("header", { role: "banner", className: "fixed w-screen z-30 h-16 py-3 px-5 bg-white flex items-center border-b border-app-gray-line " },
        React.createElement("div", { className: "mr-12" },
            React.createElement(Link, { to: "/" },
                React.createElement("img", { src: "/images/sweetspot-logo.svg", alt: "SweetSpot", width: "150", height: "37" }))),
        React.createElement("nav", null,
            React.createElement("ul", { className: "flex space-x-4" },
                React.createElement("li", null,
                    React.createElement(NavLink, { to: "/patients", className: navLinkClassName }, "Patients")),
                React.createElement("li", null,
                    React.createElement(NavLink, { to: "/trends", className: navLinkClassName }, "Trends")),
                React.createElement("li", null,
                    React.createElement(NavLink, { to: "/billing", className: navLinkClassName }, "Billing")),
                React.createElement("li", null,
                    React.createElement("a", { style: { cursor: 'pointer' }, className: navLinkClassName({ isActive }), onClick: handleTasksMenuClick },
                        "Tasks ",
                        React.createElement(Badge, { badgeContent: tasksCount, color: "error" },
                            React.createElement(FactCheckOutlined, { style: { fontSize: '1rem' } })))),
                showTasksMenu && (React.createElement("div", null,
                    React.createElement(Menu, { anchorEl: tasksAnchorEl, open: showTasksMenu, onClose: handleCloseTasksMenu },
                        React.createElement(NavLink, { to: "/tasks" },
                            React.createElement(MenuItem, null,
                                React.createElement(Group, null),
                                " View Tasks")),
                        React.createElement(MenuItem, { onClick: () => setShowAddTasksModal(true) },
                            " ",
                            React.createElement(ControlPointOutlined, null),
                            " Add Task")))),
                showAddTasksModal && React.createElement(AddTaskModal, { onRequestClose: () => setShowAddTasksModal(false), url: currentUrl, onTaskAdded: () => setShowAddTasksModal(false) }))),
        React.createElement("div", { className: "ml-auto flex" },
            React.createElement("div", { style: {
                    fontFamily: 'Barlow',
                    fontWeight: '400',
                    color: '#00000099',
                    fontSize: '14px',
                    marginRight: '5px',
                    marginTop: 'auto',
                    marginBottom: 'auto'
                } }, userProfile.practiceName),
            React.createElement("div", { className: "flex rounded-l-lg py-1 px-2 items-center" },
                React.createElement(Button, { onClick: (event) => handleProfileMenuClick(event) },
                    React.createElement(Avatar, { className: "w-10 h-10 mr-2", alt: "My Avatar", placeholderLabel: `${userProfile.firstname[0]}${userProfile.lastname[0]}`, sources: [] })),
                showProfileActions && (React.createElement("div", null,
                    React.createElement(Menu, { anchorEl: anchorEl, open: showProfileActions, onClose: handleCloseProfileActions },
                        React.createElement(MenuItem, null, `${userProfile.firstname} ${userProfile.lastname}`),
                        React.createElement(MenuItem, null, userProfile.email),
                        React.createElement("a", { target: "_blank", href: 'https://aegisdigitalhealth.zendesk.com/hc/en-us/categories/14551401504919-General-Info', rel: "noreferrer" },
                            React.createElement(MenuItem, null,
                                React.createElement(BookOutlined, { style: { color: '#0000008A' } }),
                                " Clinic Resources")),
                        React.createElement(NavLink, { to: "/settings/home" },
                            React.createElement(MenuItem, null,
                                React.createElement(SettingsOutlined, { style: { color: '#0000008A' } }),
                                " Settings")),
                        (userProfile.cpoDashboardAccess) &&
                            React.createElement(NavLink, { to: '/cpo-dashboard' },
                                React.createElement(MenuItem, null, "CPO Dashboard")),
                        userProfile.email.includes('aegisdigitalhealth') &&
                            React.createElement(MenuItem, { onClick: launchAegisDashboard }, "Aegis Dashboard"),
                        React.createElement(MenuItem, { onClick: signOut },
                            React.createElement(Logout, { style: { color: '#D32F2F' } }),
                            " Sign out"))))))));
};
